// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"701a21c8","274":"e8e4a776"}[chunkId] + ".chunk.css";
};